module.exports = __webpack_public_path__ + "static/img/白板投影.c209eee4.png";